import React, { useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import {
  AppstoreAddOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  LogoutOutlined,
  UserOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { KICFooter, KICHeader } from "../../components/Common";

import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/NC_technologies.jpg";
import { logOut, selectIsFirstTimeLogin } from "store/slices";
import { useDispatch, useSelector } from "react-redux";
import "./style.css";

const Dashboard = () => {
  const { Header, Footer, Sider, Content } = Layout;
  const location = useLocation();
  const active = location.pathname.split("/")[2];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isFirstTimeLogin = useSelector(selectIsFirstTimeLogin);
  const disableItem = isFirstTimeLogin;

  const [collapsed, setCollapsed] = React.useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const isMobileMedium = window.innerWidth <= 768;
  const isMobileLarge = window.innerWidth <= 1024;
  const isMobileSmall = window.innerWidth <= 640;
  const isMobile = isMobileMedium || isMobileLarge || isMobileSmall;

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const useScrollLock = (isLocked: boolean) => {
    useEffect(() => {
      if (isLocked) {
        const scrollY = window.scrollY;

        document.body.classList.add("overflow-hidden");
        document.body.classList.add("fixed");
        document.body.classList.add("inset-x-0");
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = "100%";
      } else {
        const scrollY = document.body.style.top;

        document.body.classList.remove("overflow-hidden");
        document.body.classList.remove("fixed");
        document.body.classList.remove("inset-x-0");
        document.body.style.top = "";
        document.body.style.width = "";

        if (scrollY) {
          window.scrollTo(0, parseInt(scrollY || "0") * -1);
        }
      }

      return () => {
        document.body.classList.remove("overflow-hidden");
        document.body.classList.remove("fixed");
        document.body.classList.remove("inset-x-0");
        document.body.style.top = "";
        document.body.style.width = "";
      };
    }, [isLocked]);
  };

  const openMobileMenu = () => {
    setIsOpen(!isOpen);
  };

  const headerStyle: React.CSSProperties = {
    height: 64,
    paddingInline: 12,
    lineHeight: "64px",
    position: "fixed",
    zIndex: 1,
    width: "100%",
    maxWidth: "100%",
    top: 0,
    left: 0,
    paddingLeft: collapsed ? 80 : 200,
    transition: "all 0.3s ease-in-out",
  };

  const layoutStyle = {
    overflow: "hidden",
    width: "100%",
    maxWidth: "100%",
  };
  const contentStyle = {
    paddingInline: 12,
    paddingTop: 32,
    paddingBottom: 12,
    lineHeight: "120px",
    paddingLeft: isMobile ? 18 : 32,
    paddingRight: 18,
    minHeight: "calc(100vh - 60px)",
    marginLeft: collapsed ? "80px" : "200px",
    transition: "0.3s",
    marginTop: 64,
  };

  const siderStyle: React.CSSProperties = {
    lineHeight: "120px",
    // backgroundColor: "#31383e",
    height: "100vh",
    position: "fixed",
    overflow: "auto",
    zIndex: 80,
    left: 0,
    width: isOpen ? "100%" : "",
  };
  const footerStyle: React.CSSProperties = {
    textAlign: "right",
  };

  useScrollLock(isOpen);

  const menuItems = [
    {
      label: "Dashboard",
      icon: <AppstoreAddOutlined />,
      link: "overview",
      key: "1",
      disabled: disableItem,
    },

    {
      label: "Submit a Deposit",
      icon: <WalletOutlined />,
      link: "submit-deposit",
      key: "3",
      disabled: disableItem,
    },
    {
      label: "Loans",
      icon: <FileDoneOutlined />,
      link: "apply-for-loan",
      key: "5",
      disabled: disableItem,
    },

    {
      label: "Transactions",
      icon: <FileSearchOutlined />,
      link: "transactions",
      key: "7",
      disabled: disableItem,
    },
    // {
    //   label: "Request Withdraw",
    //   icon: <DollarOutlined />,
    //   link: "request-withdraw",
    //   key: "8",
    // },
    // {
    //   label: "Apply For Shares",
    //   icon: <UsergroupAddOutlined />,
    //   link: "apply-for-shares",
    //   key: "6",
    // },
    // {
    //   label: "Accounts",
    //   icon: <SolutionOutlined />,
    //   link: "accounts",
    //   key: "2",
    // },
    {
      label: "Profile",
      icon: <UserOutlined />,
      link: "profile",
      key: "9",
      disabled: disableItem,
    },
    {
      label: "Logout",
      icon: <LogoutOutlined />,
      link: "/",
      key: "10",
      onClick: () => {
        dispatch(logOut());
        navigate("/");
      },
    },
  ];
  return (
    <Layout style={layoutStyle} className=" relative">
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-20 h-screen transition-opacity duration-300"
          onClick={() => setIsOpen(false)}
          aria-hidden="true"
        />
      )}
      <Sider
        theme="light"
        width="200px"
        style={siderStyle}
        trigger={null}
        collapsible
        collapsed={collapsed}
        className={` mookh-sidebar  transform transition-transform duration-300 ease-in-out 
        ${isOpen ? "translate-x-0" : "max-lg:-translate-x-full"}`}
      >
        <div className="text-center h-16 bg-white ">
          <h2 className="  text-2xl font-bold text-gray-800 leading-8 py-4 px-2 border border-b-2 flex items-center justify-center p-4">
            <img
              src={Logo}
              className="w-14 h-14 max-w-full"
              alt="NC technologies logo"
            />
          </h2>
        </div>
        <Menu
          className="bg-white w-full h-auto font-sans font-medium pt-8"
          theme="light"
          mode="inline"
          defaultSelectedKeys={["overview"]}
          selectedKeys={[active]}
        >
          {menuItems.map((item) => (
            <Menu.Item
              key={item.link}
              icon={item.icon}
              style={{ color: "#1677ff" }}
              onClick={item.onClick}
              disabled={item.disabled}
            >
              <NavLink to={item?.link}>{item.label}</NavLink>
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout>
        <Header style={headerStyle} className="bg-white">
          <KICHeader
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            openMobileMenu={openMobileMenu}
          />
        </Header>
        <Content style={contentStyle}>
          <Outlet />
        </Content>
        <Footer style={footerStyle} className="bg-white">
          <KICFooter />
        </Footer>
      </Layout>
    </Layout>
  );
};

export default Dashboard;
